import sharedService from "@/services/shared.service";
import authorizationService from "@/services/authorization.service";

const state = {
    user: null,
    hasModal: false,
    allProfessions: Array,
    allWorkerQualifications: Array,
    allRegions: Array
};

const getters = {
    user: (state) => state.user,
    isUserAdmin: (state) => state.user && (state.user.role === 'ADMIN' || state.user.role === 'SUPER_ADMIN'),
    isUserSuperAdmin: (state) => state.user && state.user.role === 'SUPER_ADMIN',
    hasModal: (state) => state.hasModal,
    allProfessions: (state) => state.allProfessions,
    allWorkerQualifications: (state) => state.allWorkerQualifications,
    allRegions: (state) => state.allRegions
};

const actions = {
    fetchUser({commit}) {
        authorizationService.getLoggedInUser()
            .then(({data}) => {
                commit('setUser', data);
            });
    },
    fetchAllProfessions({commit}) {
        sharedService.fetchAllProfessions()
            .then(({data}) => {
                commit('setAllProfessions', data);
            });
    },
    fetchAllWorkerQualifications({commit}) {
        sharedService.fetchAllWorkerQualifications()
            .then(({data}) => {
                commit('setAllWorkerQualifications', data);
            });
    },
    fetchAllRegions({commit}) {
        sharedService.fetchAllRegions()
            .then(({data}) => {
                commit('setAllRegions', data);
            });
    }
};

const mutations = {
    setUser: (state, user) => (state.user = user),
    setHasModal: (state, hasModal) => (state.hasModal = hasModal),
    setAllProfessions: (state, allProfessions) => (state.allProfessions = allProfessions),
    setAllWorkerQualifications: (state, allWorkerQualifications) => (state.allWorkerQualifications = allWorkerQualifications),
    setAllRegions: (state, regions) => (state.allRegions = regions)
};

export default {
    state,
    getters,
    actions,
    mutations
};
